import React from 'react';
import { withRouter } from 'react-router-dom';
import { Guideline } from '../../Helpers/getGuideline';
import FileUploader from '../FileUploader/FileUploader';
import FormSection from '../Form/FormSection/FormSection';
import FormAction from '../Form/FormAction';
import { t } from 'i18next';
// import { useTranslation } from 'react-i18next';

const AddImportFile = ({ ...props }) => {
  // const { t } = useTranslation();

  let handleImportFile = props.handleImportFile;
  let handleImportDuplicate = props.handleImportDuplicate;
  let handleImportType = props.handleImportType;
  let onFileDrop = props.onFileDrop;
  let csvFile = props.csvFile;
  let duplicate = props.duplicate;
  let importType = props.importType;
  // let sampleFileLink = props.sampleFileLink
  let disableNext = props.disableNext;

  return (
    <FormSection title={t("Contacts.select_file")}>
      <form onSubmit={handleImportFile}>
        <section>
          <div className="subtitle">{t("Contacts.import_from")}</div>
          <div className="radio-container">
            <select
              className="form-field inline-field"
              value={importType}
              name="importType"
              id="importType"
              onChange={handleImportType}
            >
              <option value="seebiz">{t("Contacts.seebiz_csv_file")}</option>
              <option value="zoho">{t("Contacts.zoho_csv_file")}</option>
              <option value="quickbookc">{t("Contacts.quick_book_export_csv_file")}</option>
              <option value="quickbookr">{t("Contacts.quick_book_report_csv_file")}</option>
            </select>
          </div>
        </section>
        <section>
          <div className="subtitle">
            {t("Contacts.steps_to_prepare_data")}          </div>
          {Guideline(importType, window.location.pathname)}
          {/* <div className="import-file--sample">
          Download a <a
          href={sampleFileLink}
          rel="noopener noreferrer"
          target="_blank">sample file</a> for SeeBiz reference so you may ensure you have an acceptable file.
        </div> */}
          <br />
          <div className="subtitle">{t("Contacts.upload_file")}</div>
          {csvFile.name !== undefined && <div>{csvFile.name}</div>}
          <FileUploader accept=".CSV" onDrop={onFileDrop} />
          <div>{t("Contacts.file_formate_excepted_csv")}</div>
        </section>

        <section>
          <div className="subtitle">{t("Contacts.duplicate_records")}</div>
          <div className="radio-container">
            <div className="radio-btn">
              <input
                type="radio"
                id="skip"
                value="skip"
                checked={duplicate === 'skip'}
                onChange={handleImportDuplicate}
              />
              <label htmlFor="skip">{t("Contacts.skip")}</label>
              <span className="radio-circle" />
            </div>
            <div className="radio-btn">
              <input
                type="radio"
                id="overwrite"
                value="overwrite"
                checked={duplicate === 'overwrite'}
                onChange={handleImportDuplicate}
              />
              <label htmlFor="overwrite">{t("Contacts.overwrite")}</label>
              <span className="radio-circle" />
            </div>
          </div>
        </section>

        <FormAction
          submitLabel={t("Contacts.next")}

          disabled={disableNext}
          onCancel={() => props.history.goBack()}
        />
      </form>
    </FormSection>
  );
};

export default withRouter(AddImportFile);
